#map {
  height: 100%;
}

// animates marker bouncing up and down every 700ms
/* Define the animation */
@keyframes bounceAnimation {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
    transform: scale(1.15);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

#map
  > div.gm-style
  > div:nth-child(2)
  > div:nth-child(1)
  > div:nth-child(4)
  > div {
  overflow: visible !important;

  img {
    animation: bounceAnimation 1.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      infinite;
  }
}
